;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:ENCON_SENTRY_KEY":true});}catch(e){}}();import {Checkbox} from './Checkbox'
import {Country} from './Country'
import {Email} from './Email'
import {Message} from './Message'
import {Number} from './Number'
import {Select} from './Select'
import {State} from './State'
import {Text} from './Text'
import {Textarea} from './Textarea'
import {Upload} from "./Upload/Component";

export const fields = {
	checkbox: Checkbox,
	country: Country,
	email: Email,
	message: Message,
	number: Number,
	select: Select,
	state: State,
	text: Text,
	textarea: Textarea,
	upload: Upload,
};
